import axios from 'axios'
import store from '../store'
import { errorLogger, handleErrorMessage } from '@/utils/errorHandler'
import tokenMixin from '@/mixins/token'

export default function setupInterceptors () {
  // flag to track if a 401 error has been encountered by a request
  const hasEncountered401Error = store.state.error.hasEncountered401Error

  axios.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      // get error message
      const errorMessage = handleErrorMessage(error)
      // spread axios error object and customMessage into a single object and log in the store
      errorLogger({
        ...error,
        customMessage: errorMessage,
        publicMessage: error?.response?.data?.error?.publicMessage || ''
      })
      return Promise.reject(error)
    }
  )
  axios.interceptors.request.use(
    function (config) {
      const accessToken = tokenMixin.methods.getToken()
      const tenant = process.env.VUE_APP_TENANT_NAME

      // get timezone.
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

      // cancel request
      if (hasEncountered401Error && !accessToken) {
        const cancelTokenSource = axios.CancelToken.source()
        config.cancelToken = cancelTokenSource.token
        cancelTokenSource.cancel('Session has expired!')
        return config
      }
      config.headers['X-Timezone'] = timezone
      // add bearer token if present
      if (accessToken || tenant) {
        config.headers.Authorization = `Bearer ${accessToken}`
        config.headers.tenant = tenant
      }

      return config
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )
}
